/**
 * 配置浏览器本地存储的方式，可直接存储对象数组。
 */

import WebStorageCache from 'web-storage-cache'

type CacheType = 'localStorage' | 'sessionStorage'

const WS_PREFIX = 'WEB_'

export const CACHE_KEY = {
  // 用户相关
  ROLE_ROUTERS: `${WS_PREFIX}roleRouters`,
  USER: `${WS_PREFIX}user`,
  // 系统设置
  IS_DARK: `${WS_PREFIX}isDark`,
  LANG: `${WS_PREFIX}lang`,
  THEME: `${WS_PREFIX}theme`,
  LAYOUT: `${WS_PREFIX}layout`,
  DICT_CACHE: `${WS_PREFIX}dictCache`,
  // 登录表单
  LoginForm: `${WS_PREFIX}loginForm`,
}

export const useCache = (type: CacheType = 'localStorage') => {
  const wsCache: WebStorageCache = new WebStorageCache({
    storage: type,
  })

  return {
    wsCache,
    WS_PREFIX,
  }
}

export const deleteUserCache = () => {
  const { wsCache } = useCache()
  wsCache.delete(CACHE_KEY.USER)
  wsCache.delete(CACHE_KEY.ROLE_ROUTERS)
  // 注意，不要清理 LoginForm 登录表单
}
